var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("If you can see this page it means there is something wrong. Please check the configuration file.")])
}
var staticRenderFns = []

export { render, staticRenderFns }